import { matchPath } from "react-router-dom";
import { PATHS } from "@constants/Paths";
/**
 * Maps each route to a stable, human-readable name used as the `routeName`
 * property on page-view events. Keep these in sync with `PATHS`.
 */
const ROUTE_NAMES = {
    [PATHS.LANDING]: "landing",
    [PATHS.WELCOME]: "welcome",
    [PATHS.REPORT_TYPE]: "report-type",
    [PATHS.CHECKOUT]: "checkout",
    [PATHS.LOGIN]: "login",
    [PATHS.DEMO]: "demo",
    [PATHS.FORGOT_PASSWORD]: "forgot-password",
    [PATHS.RESET_PASSWORD]: "reset-password",
    [PATHS.LOGIN_ERROR]: "login-error",
    [PATHS.AUTH_ERROR]: "auth-error",
    [PATHS.HOME]: "home",
    [PATHS.OVERVIEW]: "overview",
    [PATHS.RESULTS]: "results",
    [PATHS.ADMIN_DASHBOARD]: "admin-dashboard",
    [PATHS.TERMS_CONDITIONS_AGREEMENT]: "terms-conditions-agreement",
    [PATHS.COMMUNITY]: "community",
    [PATHS.NEW_REPORT]: "new-report",
    [PATHS.REPORT_SETTINGS]: "report-settings",
    [PATHS.INVALID_TOKEN]: "invalid-token",
};
/**
 * Resolves a concrete pathname to its route template, name, and params.
 * `matchPath` is exact by default in React Router v6, so more specific routes
 * (e.g. `/login/login-error`) never collide with their prefixes (`/login`).
 * Unknown paths (e.g. 404s) resolve to `routeName: "unknown"`.
 */
export const resolveRoute = (pathname) => {
    for (const pattern of Object.keys(ROUTE_NAMES)) {
        const match = matchPath(pattern, pathname);
        if (match) {
            return { path: pattern, routeName: ROUTE_NAMES[pattern], params: match.params };
        }
    }
    return { path: pathname, routeName: "unknown", params: {} };
};
